import { type PropsWithChildren } from 'react';
import classNames from 'classnames';

import { Card } from '~/components/OddscheckerPlus/components/cxy';

import styles from './styles/ProductCard.module.css';

export function ProductCard({
  children,
  image,
  title,
  ...props







}: {image?: {alt: string;position?: 'leading' | 'trailing';src: string;};title?: string;} & PropsWithChildren) {
  return (
    <Card
      borderRadius="l"
      className={classNames(styles.productCard, {
        [styles[`image--${image?.position}`]]: image?.position
      })}
      variant="secondary"
      {...props}>

			{title ? <h2 className={styles.title}>{title}</h2> : ''}
			{image &&
      <div className={styles.imageContainer}>
					<img alt={image.alt} src={image.src} />
				</div>
      }
			<div className={styles.textContainer}>{children}</div>
		</Card>);

}